(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-recommendation"] && !Shopify.designMode) return;
  try {
    (() => {
    const storageKey = 'pd-market-language-recommendation-v2';
    const day = 86400000;
    const normalize = (value) => String(value || '').toLowerCase().split('-')[0];
    const normalizeCountry = (value) => String(value || '').toUpperCase();
    const copy = {
      en: {
        prompt: 'Shop in the right market and language?',
        detail: 'We detected {country}. View local prices and continue in {language}.',
        action: 'Switch to {country}'
      },
      ja: {
        prompt: 'お住まいの地域と言語に切り替えますか？',
        detail: '{country}向けの価格を表示し、{language}でお買い物いただけます。',
        action: '{country}に切り替える'
      },
      ar: {
        prompt: 'هل تريد التسوق حسب منطقتك ولغتك؟',
        detail: 'يبدو أنك في {country}. اعرض الأسعار المحلية وتابع باللغة {language}.',
        action: 'التبديل إلى {country}'
      },
      he: {
        prompt: 'לעבור לאזור ולשפה המתאימים לך?',
        detail: 'נראה שאתם נמצאים ב-{country}. הציגו מחירים מקומיים והמשיכו ב-{language}.',
        action: 'מעבר אל {country}'
      },
      de: {
        prompt: 'Zum passenden Markt und zur passenden Sprache wechseln?',
        detail: 'Ihr Standort scheint {country} zu sein. Lokale Preise anzeigen und auf {language} fortfahren.',
        action: 'Zu {country} wechseln'
      },
      fr: {
        prompt: 'Afficher le marché et la langue adaptés ?',
        detail: 'Votre localisation semble être {country}. Affichez les prix locaux et continuez en {language}.',
        action: 'Passer à {country}'
      },
      es: {
        prompt: '¿Cambiar al mercado y al idioma adecuados?',
        detail: 'Parece que estás en {country}. Consulta los precios locales y continúa en {language}.',
        action: 'Cambiar a {country}'
      }
    };
    const marketLanguage = {
      AE: 'ar',
      AU: 'en',
      CA: 'en',
      DE: 'de',
      ES: 'es',
      GB: 'en',
      IL: 'he',
      JP: 'ja',
      MY: 'en',
      NZ: 'en',
      PH: 'en',
      SA: 'ar',
      SG: 'en',
      UM: 'en',
      US: 'en',
      ZA: 'en'
    };
    const countryAlias = { UM: 'US' };
    const readPreference = () => {
      try {
        const preference = JSON.parse(localStorage.getItem(storageKey) || 'null');
        if (!preference || preference.expiresAt < Date.now()) return null;
        return preference;
      } catch (error) {
        return null;
      }
    };
    const writePreference = (preference) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(preference));
      } catch (error) {
        return;
      }
    };
    const recordChoice = (country, locale) => {
      writePreference({
        chosenCountry: normalizeCountry(country),
        chosenLocale: normalize(locale),
        expiresAt: Date.now() + 365 * day
      });
    };

    document.addEventListener('submit', (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      const localeInput = event.target.querySelector('input[name="locale_code"]');
      const countryInput = event.target.querySelector('input[name="country_code"]');
      if (localeInput?.value || countryInput?.value) {
        recordChoice(countryInput?.value || window.Shopify?.country, localeInput?.value || document.documentElement.lang);
      }
    });

    const detectCountry = async () => {
      try {
        const response = await fetch('/browsing_context_suggestions.json', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) return '';
        const data = await response.json();
        return normalizeCountry(data?.detected_values?.country?.handle);
      } catch (error) {
        return '';
      }
    };

    const initialize = async () => {
      if (window.Shopify?.designMode) return;
      const rawDetectedCountry = await detectCountry();
      const detectedCountry = countryAlias[rawDetectedCountry] || rawDetectedCountry;
      document.querySelectorAll('[data-pd-language-recommendation]').forEach((recommendation) => {
        const currentLocale = normalize(recommendation.dataset.currentLocale);
        const currentCountry = normalizeCountry(window.Shopify?.country);
        const options = [...recommendation.querySelectorAll('[data-pd-language-option]')];
        const supported = new Map(options.map((option) => [normalize(option.dataset.baseLocale), option]));
        const countries = new Map(
          [...recommendation.querySelectorAll('[data-pd-country-option]')].map((option) => [
            normalizeCountry(option.dataset.countryCode),
            option.dataset.countryName
          ])
        );
        const browserLocales = Array.isArray(navigator.languages) && navigator.languages.length
          ? navigator.languages
          : [navigator.language];
        const browserLocale = browserLocales.map(normalize).find((locale) => supported.has(locale));
        const locationLocale = marketLanguage[detectedCountry];
        const detectedLocale = browserLocale || (supported.has(locationLocale) ? locationLocale : currentLocale);
        const countryMismatch = detectedCountry && countries.has(detectedCountry) && detectedCountry !== currentCountry;
        const languageMismatch = detectedLocale && detectedLocale !== currentLocale;
        if (!countryMismatch && !languageMismatch) return;

        const preference = readPreference();
        if (preference?.chosenCountry || preference?.chosenLocale) return;
        if (
          preference?.dismissedCountry === detectedCountry &&
          preference?.dismissedLocale === detectedLocale
        ) return;

        const selectedOption = supported.get(detectedLocale) || supported.get(currentLocale);
        const switchButton = selectedOption?.querySelector('[data-prompt]');
        const prompt = recommendation.querySelector('[data-pd-language-prompt]');
        const detail = recommendation.querySelector('[data-pd-language-detail]');
        if (!selectedOption || !switchButton || !prompt || !detail) return;

        const targetCountry = countryMismatch ? detectedCountry : currentCountry;
        const countryName = countries.get(targetCountry) || targetCountry;
        const languageName = switchButton.textContent.replace('→', '').trim();
        const currentCopy = copy[currentLocale] || copy.en;
        if (countryMismatch) {
          prompt.textContent = currentCopy.prompt;
          detail.textContent = currentCopy.detail
            .replace('{country}', countryName)
            .replace('{language}', languageName);
          switchButton.textContent = currentCopy.action.replace('{country}', countryName) + ' →';
        } else {
          prompt.textContent = switchButton.dataset.prompt;
          detail.textContent = switchButton.dataset.detail;
        }

        const form = selectedOption.querySelector('form');
        if (form && targetCountry) {
          let countryInput = form.querySelector('input[name="country_code"]');
          if (!countryInput) {
            countryInput = document.createElement('input');
            countryInput.type = 'hidden';
            countryInput.name = 'country_code';
            form.appendChild(countryInput);
          }
          countryInput.value = targetCountry;
        }

        selectedOption.hidden = false;
        recommendation.dir = detectedLocale === 'ar' || detectedLocale === 'he' ? 'rtl' : 'ltr';
        recommendation.hidden = false;
        requestAnimationFrame(() => recommendation.classList.add('is-visible'));

        const dismiss = () => {
          recommendation.classList.remove('is-visible');
          writePreference({
            dismissedCountry: detectedCountry,
            dismissedLocale: detectedLocale,
            expiresAt: Date.now() + 30 * day
          });
          window.setTimeout(() => {
            recommendation.hidden = true;
          }, 240);
        };

        recommendation.querySelectorAll('[data-pd-language-dismiss]').forEach((button) => {
          button.addEventListener('click', dismiss, { once: true });
        });
        recommendation.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') dismiss();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
      initialize();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
